// React hooks
import { useEffect } from "react";

// State management
import { useAppDispatch, useAppSelector } from "../../services/StoreHelper";
import { update_state_value } from "../../store/reducers/AppReducer";

// Services
import { get_agreements } from "../../services/global.services";

// Components and styles
import MobileCard from "./MobileCard/MobileCard";
import mobile_user_portal_styles from "./mobile_user_portal_styles";
import { BounceLoader } from "react-spinners";

function MobileUserPortal() {
  const dispatch = useAppDispatch();
  const { app_loading, club, agreements } = useAppSelector(
    (state) => state.app
  );

  useEffect(() => {
    get_agreements(dispatch, update_state_value);
  }, [dispatch]);

  if (app_loading || !club.clubId) {
    return (
      <div style={mobile_user_portal_styles.loader}>
        <BounceLoader />
      </div>
    );
  }

  return (
    <div style={mobile_user_portal_styles.mobile_user_portal}>
      <div style={mobile_user_portal_styles.form}>
        {agreements.map((contract: any) => (
          <MobileCard
            key={contract.id || contract.contractId}
            contract={contract}
            refresh={() => get_agreements(dispatch, update_state_value)}
          />
        ))}
      </div>
    </div>
  );
}

export default MobileUserPortal;